import { render, staticRenderFns } from "./ClientsContactDetails.vue?vue&type=template&id=a1699c44&scoped=true"
import script from "./ClientsContactDetails.vue?vue&type=script&lang=ts"
export * from "./ClientsContactDetails.vue?vue&type=script&lang=ts"
import style0 from "./ClientsContactDetails.vue?vue&type=style&index=0&id=a1699c44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1699c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1699c44')) {
      api.createRecord('a1699c44', component.options)
    } else {
      api.reload('a1699c44', component.options)
    }
    module.hot.accept("./ClientsContactDetails.vue?vue&type=template&id=a1699c44&scoped=true", function () {
      api.rerender('a1699c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients-contacts/components/ClientsContactDetails.vue"
export default component.exports